export interface SegmentedControlOption {
  value: string;
  label: string;
}

export const MUNILY_SEGMENTED_CONTROL_DEFAULTS = {
  value: '',
} as const;
